<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar dense :color="'#FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row no-gutters class="px-2 px-md-6 pb-6">
            <v-col cols="12" md="3" lg="2" class="pt-4 pr-md-4">
                <menu-lateral-central-reservas
                    :opciones="menuLateralOpciones"
                    :activo="menuLateralActual"
                    :color-fondo="'#FBFAF1'"
                    :color-activo="miColorAzul"
                    @seleccionar="seleccionarMenuLateral"
                    @cerrar-sesion="_cerrarSesion"
                />
            </v-col>
            <v-col cols="12" md="9" lg="10" class="pt-4">
                <nueva-solicitud-section v-if="menuLateralActual === 'nueva_solicitud'" :key="nuevaSolicitudKey" />
                <expedientes-section v-else-if="menuLateralActual === 'expedientes'" />
                <proformas-section v-else-if="menuLateralActual === 'proformas'" />
                <perfil-agencia-section v-else-if="menuLateralActual === 'perfil_agencia'" />
                <ayuda-section v-else />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import MenuLateralCentralReservas from '@/components/central-reservas/MenuLateralCentralReservas.vue';
import NuevaSolicitudSection from '@/components/central-reservas/NuevaSolicitudSection.vue';
import ExpedientesSection from '@/components/central-reservas/ExpedientesSection.vue';
import ProformasSection from '@/components/central-reservas/ProformasSection.vue';
import AyudaSection from '@/components/central-reservas/AyudaSection.vue';
import PerfilAgenciaSection from '@/components/central-reservas/PerfilAgenciaSection.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        MenuLateralCentralReservas,
        NuevaSolicitudSection,
        ExpedientesSection,
        ProformasSection,
        AyudaSection,
        PerfilAgenciaSection
    },
    watch: {
        '$route.fullPath': {
            immediate: true,
            handler() {
                this.syncMenuFromRoute();
            }
        }
    },
    computed: {
        ...mapState('auth', ['access_token', 'user'])
    },
    data() {
        return {
            menuLateralActual: 'nueva_solicitud',
            nuevaSolicitudKey: 0,
            menuLateralOpciones: [
                { id: 'nueva_solicitud', titulo: 'Nueva Solicitud', icono: 'mdi-plus-box' },
                { id: 'expedientes', titulo: 'Expedientes', icono: 'mdi-file-document-outline' },
                { id: 'proformas', titulo: 'Proformas', icono: 'mdi-file-document-multiple-outline' },
                { id: 'perfil_agencia', titulo: 'Perfil Agencia', icono: 'mdi-office-building-outline' },
                { id: 'ayuda', titulo: 'Ayuda', icono: 'mdi-help-circle-outline' }
            ],
            miColorAzul: '#191970'
        };
    },
    methods: {
        ...mapActions('auth', ['logOut']),

        getMenuValido(menuId) {
            if (!menuId && this.$route.query.codigo) {
                return 'expedientes';
            }

            return this.menuLateralOpciones.some(opcion => opcion.id === menuId)
                ? menuId
                : 'nueva_solicitud';
        },

        syncMenuFromRoute() {
            const menuId = this.getMenuValido(this.$route.query.tab);
            if (this.menuLateralActual !== menuId) {
                this.menuLateralActual = menuId;
            }
        },

        actualizarQueryMenu(menuId) {
            const tab = this.getMenuValido(menuId);
            const queryActual = this.$route.query || {};
            const siguienteQuery = {
                ...queryActual,
                tab
            };

            if (tab !== 'expedientes') {
                delete siguienteQuery.codigo;
            }

            const mismaTab = (queryActual.tab || '') === (siguienteQuery.tab || '');
            const mismoCodigo = (queryActual.codigo || '') === (siguienteQuery.codigo || '');
            if (mismaTab && mismoCodigo) return;

            this.$router.replace({ query: siguienteQuery }).catch(() => {});
        },

        seleccionarMenuLateral(menuId) {
            if (menuId === 'nueva_solicitud') {
                this.nuevaSolicitudKey++;
            }
            this.menuLateralActual = menuId;
            this.actualizarQueryMenu(menuId);
        },

        async _cerrarSesion() {
            await this.logOut([this.access_token]);
            this.$router.push('/login');
        }
    }
};
</script>
